export const GROUP_TITLE_CHARACTER_LIMIT = 20;
